export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/account/register', '/accounts/registration', '#create_customer');
  });
}
